module.exports = __webpack_public_path__ + "img/Invasion-BRCA_her2st.e3328632.png";